module.exports = __webpack_public_path__ + "img/spain.98710a1d.jpg";